import axios  from '@/axios-mock'

let mock = {
  province : null,
  city : null,
  district : null,
  show: false,
  choose: [0, 0, 0],
  history: null
}

let requestHistory = {}

function selectProvince (regionId =1){
  
  
  if(mock.province){
    return Promise.resolve(mock.province)
  }else{
    mock.choose[0] =0
    let _url = `/app/area/region/${regionId}/province`
    let _history = requestHistory[_url]
    
    if(_history !== undefined){
      return Promise.resolve(_history)
    }

    return new Promise((resolve, reject) => {
      axios({
        url: _url
      })
      .then(({ data }) => {

        resolve(data)
        requestHistory[_url] = data
      })
      .catch(function (error) {
        reject(error)
      })
      // instance.get(_url)
      //   .then(function (response) {
      //     let data = response.data
      //     resolve(data)
      //     requestHistory[_url] = data
      //   })
      //   .catch(function (error) {
      //     reject(error)
      //   })
    })
  }
}
function selectCity (province){
  let provinceId = province.id
  if(mock.history
        && mock.city
        && provinceId === mock.history.province){
    return Promise.resolve(mock.city)
  }else{
    mock.choose[1] =0
    let _url = `/app/area/province/${provinceId}/city`
    let _history = requestHistory[_url]
    if(_history !== undefined){
      return Promise.resolve(_history)
    }
    return new Promise((resolve, reject) => {
      axios({
        url: _url
      })
      .then(({ data }) => {
        resolve(data)
        requestHistory[_url] = data
      })
      .catch(function (error) {
        reject(error)
      })
      // instance.get(_url)
      //   .then(function (response) {
      //     let data = response.data
      //     resolve(data)
      //     requestHistory[_url] = data
      //   })
      //   .catch(function (error) {
      //     reject(error)
      //   })
    })
  }
}
function selectDistrict (city){
  let cityId = city.id

  if(mock.history
        && mock.district
        && cityId === mock.history.city){
    return Promise.resolve(mock.district)
  }else{
    mock.choose[2] =0
    let _url = `/app/area/city/${cityId}/district`
    let _history = requestHistory[_url]
    if(_history !== undefined){
      return Promise.resolve(_history)
    }
    return new Promise((resolve, reject) => {
      axios({
        url: _url
      })
      .then(({ data }) => {
        data = data.filter(item => item.name !== '卢湾区' && item.name !== '闸北区')
        resolve(data)
        requestHistory[_url] = data
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }
}

export default {
   _changeChoose : function(val , index){
    mock.choose[index] = val
   },
   _getChoose: function(){
    return {
      province: {
        id: mock.province[mock.choose[0]].id,
        name: mock.province[mock.choose[0]].name
      },
      city: {
        id: mock.city[mock.choose[1]].id,
        name: mock.city[mock.choose[1]].name
      },
      district: {
        id: mock.district[mock.choose[2]].id,
        name: mock.district[mock.choose[2]].name
      }
    }
   },
   _selectChange : function(){
    let _regionId = mock.province ? mock.province[mock.choose[0]].id:1
    return new Promise((resolve, reject) => {
      selectProvince(_regionId)
      .then((data) => {
        
        mock.province = data
        return selectCity(data[mock.choose[0]])
      })
      .then((data) => {
        
        mock.city = data
        return selectDistrict(data[mock.choose[1]])
      })
      .then((data) => {
        
        mock.district = data
        mock.history = {
          province: mock.province[mock.choose[0]].id,
          city: mock.city[mock.choose[1]].id,
          district: mock.district[mock.choose[2]].id
        }
        resolve(mock)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./static/components/select-area/data.js